import { ChildProps } from "ts/types";

export default function CardFooter({ children }: ChildProps) {
  return (
    <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">{children}</div>
  );
}
